var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4"},_vm._l((Object.keys(_vm.content)),function(item){return _c('dl',{key:item,staticClass:"row"},[_c('dt',{staticClass:"col-lg-4"},[_vm._v(" "+_vm._s(item)+" ")]),_c('dd',{staticClass:"col-lg-8 mb-4"},[_vm._v(" "+_vm._s(_vm.content[item] || _vm.blankValueIndicator)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }